export default "/images/vendor/@coreui/icons/svg/flag/cif-vc.svg?14d3bd352014fd513a6376b552b247af";